"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/SetupFlow.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _types = require('web/screens/Signup/types');
var _components = require('web/screens/Signup/components');
var _utils = require('web/screens/Signup/utils');
var _signup = require('shared/enum/signup');

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _useIntermediateValues = require('./hooks/useIntermediateValues');
var _useStep = require('./hooks/useStep');
var _signupDraft = require('./signupDraft');




var _onboardingAnalytics = require('web/services/onboardingAnalytics');
var _signupAttribution = require('web/services/signupAttribution');











var _Sections = require('./Sections');







// Card widths from the approved layout-a frames (440, 520, 640, 760, 980).
const sizes = {
  [_types.SetupSteps.PERSONAL_INFO]: 'md',
  [_types.SetupSteps.PHONE_MFA]: 'sm',
  [_types.SetupSteps.PASSWORD]: 'sm',
  [_types.SetupSteps.ORG_INFO]: 'md',
  [_types.SetupSteps.ORG_SURVEY_REFERRER]: 'sm',
  [_types.SetupSteps.PRODUCT_INTEREST]: 'lg',
  // The BAA's side-by-side attestation + document pane needs more room than
  // even the trial offer's xl card.
  [_types.SetupSteps.LEGAL_AGREEMENTS]: 'xxl',
  // The trial offer's lockup + checklist split.
  [_types.SetupSteps.TRIAL_OFFER]: 'xl',
  [_types.SetupSteps.FINISH]: 'lg',
}

const SetupFlow = ({ token, welcomeUser, onSubmitSetup }) => {
  const hasTrackedStart = _react.useRef.call(void 0, false)
  const lastTrackedStepView = _react.useRef(null)
  const wasInvitedByPhone = !!(welcomeUser.PhoneNumber && !welcomeUser.Email)
  const isPhoneRequired = _utils.isSignupPhoneRequired.call(void 0, welcomeUser, wasInvitedByPhone)
  const shouldShowPhone = _utils.shouldShowSignupPhone.call(void 0, wasInvitedByPhone)
  // Refresh-resume: land past the already-answered steps (the draft never
  // holds the password, so PASSWORD is the earliest possible landing spot).
  const resume = _react.useMemo.call(void 0, () => _signupDraft.resumeStepsFromDraft.call(void 0, _signupDraft.loadSignupDraft.call(void 0, token)), [token])
  const { currentStep, maxStep, gotoStep, goBack, clampMaxStep } = _useStep.useStep.call(void 0, resume)
  // Only email tokens have server-derived matches; phone tokens keep the
  // legacy invite flow and never fetch.
  const hasOrgMatches = !!welcomeUser.Email
  const [orgMatchState, setOrgMatchState] = _react.useState(
    () => (hasOrgMatches ? { status: 'loading' } : _types.EMPTY_SIGNUP_ORG_MATCHES),
  )
  const [orgMatchRetry, setOrgMatchRetry] = _react.useState.call(void 0, 0)
  const refreshOrgMatches = _react.useCallback.call(void 0, () => setOrgMatchRetry(retry => retry + 1), [])

  _react.useEffect.call(void 0, () => {
    if (currentStep !== _types.SetupSteps.ORG_INFO || !hasOrgMatches) return
    let active = true
    setOrgMatchState({ status: 'loading' })
    _client2.default.getSignupOrgMatches(token)
      .then(matches => {
        if (!active) return
        setOrgMatchState({ status: 'ready', matches })
        if (matches.Invites.length || matches.DomainSuggestions.length) {
          _signupAttribution.captureSignupEvent.call(void 0, 'signup organization matches shown', {
            invite_count: matches.Invites.length,
            domain_match_count: matches.DomainSuggestions.length,
            organization_ids: [
              ...matches.Invites.map(match => match.OrgKey),
              ...matches.DomainSuggestions.map(match => match.OrgKey),
            ],
            surface: 'organization_step',
          })
        }
      })
      .catch(() => {
        if (active) setOrgMatchState({ status: 'failed' })
      })
    return () => { active = false }
  }, [currentStep, orgMatchRetry, token, hasOrgMatches])
  // Persist the high-water mark so the next refresh resumes there — clamped
  // at PRODUCT_INTEREST because the legal step onward is never resumable.
  _react.useEffect.call(void 0, () => {
    _signupDraft.saveSignupDraft.call(void 0, token, { maxStep: Math.min(maxStep, _types.SetupSteps.PRODUCT_INTEREST) })
  }, [token, maxStep])
  const { values, handlers } = _useIntermediateValues.useIntermediateValues.call(void 0, {
    token,
    welcomeUser,
    wasInvitedByPhone,
    isPhoneRequired,
    gotoStep,
    currentStep,
    clampMaxStep,
    onSubmitSetup,
    // Phone tokens fall back to the welcome-token relationships signal.
    hasSignupInvites: hasOrgMatches && orgMatchState.status === 'ready'
      ? orgMatchState.matches.Invites.length > 0
      : null,
    onOrgMatchesChanged: refreshOrgMatches,
  })
  const {
    personalInfo, password, requestedOrgRels, pendingMFA,
    signupMFAChallengeKey, signupMFAMaskedPhone, phoneOnAnotherAccount, surveyAnswers, pendingSurvey,
    selectedTier, continuation, legalAccepted, stepError,
  } = values
  const {
    clearStepError,
    onSavePersonalInfo,
    onSavePassword,
    onSaveOrgRels,
    onSaveOrgSurvey,
    onSurveyAnswer,
    onSelectedTierChange,
    onStartTrial,
    onSkipTrial,
    onFreeContinue,
    onTrialOfferViewed,
    onTrialDemoViewed,
    onTrialDemo,
    onTrialSkipDialogViewed,
    onTrialPricingError,
    onDownloadFinish,
    onMFAVerified,
    onVerifySignupMFA,
    onResendSignupMFA,
    onContinueNewAccount,
    onSetLegalAccepted,
    onAcceptLegalAgreements,
  } = handlers
  // Net-new signups (SMS or free) bridge into an authenticated continuation
  // instead of the in-SPA download screen.
  const isBridge = continuation !== null

  // An error belongs to one step: leaving that step drops it.
  _react.useEffect.call(void 0, () => {
    if (stepError && stepError.step !== currentStep) clearStepError()
  }, [currentStep, stepError, clearStepError])
  const error = _optionalChain([stepError, 'optionalAccess', _ => _.step]) === currentStep ? stepError.message : undefined

  _react.useEffect.call(void 0, () => {
    if (!hasTrackedStart.current) {
      hasTrackedStart.current = true
      _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.STARTED)
    }
    if (lastTrackedStepView.current === currentStep) return

    // The offer reports its view only after public pricing renders. The
    // authenticated final screen owns the finish view for net-new signups.
    if (currentStep === _types.SetupSteps.TRIAL_OFFER ||
        (currentStep === _types.SetupSteps.FINISH && isBridge)) return

    lastTrackedStepView.current = currentStep
    _onboardingAnalytics.captureOnboardingEvent.call(void 0, 
      _onboardingAnalytics.ONBOARDING_EVENTS.STEP_VIEWED,
      _onboardingAnalytics.getStepAnalyticsProperties.call(void 0, currentStep),
    )
  }, [currentStep, isBridge])

  const renderContent = () => {
    // The post-setup login can return a sign-in code challenge from any step
    // that submits (a free signup logs in from LEGAL_AGREEMENTS), so the code
    // prompt takes over whichever step is showing.
    if (pendingMFA) return _react2.default.createElement(_Sections.MFASection, { challenge: pendingMFA, onVerified: onMFAVerified, __self: this, __source: {fileName: _jsxFileName, lineNumber: 181}} )
    switch (currentStep) {
      case _types.SetupSteps.PERSONAL_INFO: return (
        _react2.default.createElement(_Sections.PersonalInfoSection, {
          welcomeUser: welcomeUser,
          personalInfo: personalInfo,
          onSubmit: onSavePersonalInfo,
          isPhoneRequired: isPhoneRequired,
          shouldShowPhone: shouldShowPhone,
          error: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}}
        )
      )
      case _types.SetupSteps.PHONE_MFA: return (
        _react2.default.createElement(_Sections.PhoneMFASection, {
          maskedPhone: signupMFAMaskedPhone,
          onBack: () => gotoStep(_types.SetupSteps.PERSONAL_INFO),
          onVerify: onVerifySignupMFA,
          onResend: onResendSignupMFA,
          phoneOnAnotherAccount: phoneOnAnotherAccount,
          onContinueNewAccount: onContinueNewAccount, __self: this, __source: {fileName: _jsxFileName, lineNumber: 194}}
        )
      )
      case _types.SetupSteps.PASSWORD: return (
        _react2.default.createElement(_Sections.PasswordSection, {
          onBack: () => gotoStep(signupMFAChallengeKey ? _types.SetupSteps.PHONE_MFA : _types.SetupSteps.PERSONAL_INFO),
          onSubmit: onSavePassword,
          password: password,
          error: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 204}}
        )
      )
      case _types.SetupSteps.ORG_INFO: return (
        _react2.default.createElement(_Sections.OrgRelsSection, {
          onBack: goBack,
          requestedOrgRels: requestedOrgRels,
          matchState: orgMatchState,
          onRetryMatches: refreshOrgMatches,
          onSubmit: onSaveOrgRels,
          emailDomain: _optionalChain([welcomeUser, 'access', _2 => _2.Email, 'optionalAccess', _3 => _3.split, 'call', _4 => _4('@'), 'access', _5 => _5[1]]),
          error: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}}
        )
      )
      case _types.SetupSteps.ORG_SURVEY_REFERRER:
      case _types.SetupSteps.PRODUCT_INTEREST:
        // The high-level Account / Organization / Ready-to-go nav is the only
        // progress layer — the low-level survey checklist was dropped as a
        // second, redundant layer.
        return (
          _react2.default.createElement(_Sections.OrgSurveySection, {
            onBack: goBack,
            gotoStep: gotoStep,
            currentStep: currentStep,
            onSubmit: onSaveOrgSurvey,
            answers: surveyAnswers,
            onAnswer: onSurveyAnswer, __self: this, __source: {fileName: _jsxFileName, lineNumber: 228}}
          )
        )
      case _types.SetupSteps.TRIAL_OFFER:
        return (
          _react2.default.createElement(_Sections.TrialOfferSection, {
            hasSms: !!_optionalChain([pendingSurvey, 'optionalAccess', _6 => _6.productInterest, 'access', _7 => _7.includes, 'call', _8 => _8(_signup.ProductInterest.SMS)]),
            hasTeamChat: !!_optionalChain([pendingSurvey, 'optionalAccess', _9 => _9.productInterest, 'access', _10 => _10.includes, 'call', _11 => _11(_signup.ProductInterest.TEAM_CHAT)]),
            hasExternalChat: !!_optionalChain([pendingSurvey, 'optionalAccess', _12 => _12.productInterest, 'access', _13 => _13.includes, 'call', _14 => _14(_signup.ProductInterest.EXTERNAL_CHAT)]),
            onBack: goBack,
            selectedTier: selectedTier,
            onSelectedTierChange: onSelectedTierChange,
            onStart: onStartTrial,
            onSkip: onSkipTrial,
            onFreeContinue: onFreeContinue,
            onViewed: onTrialOfferViewed,
            onDemoViewed: onTrialDemoViewed,
            onDemo: onTrialDemo,
            onSkipDialogViewed: onTrialSkipDialogViewed,
            onPricingError: onTrialPricingError,
            error: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}}
          )
        )
      case _types.SetupSteps.LEGAL_AGREEMENTS:
        return (
          _react2.default.createElement(_Sections.LegalAgreementsSection, {
            orgName: _optionalChain([requestedOrgRels, 'access', _15 => _15.find, 'call', _16 => _16((rel) => !_utils.isExistingOrgRel.call(void 0, rel)), 'optionalAccess', _17 => _17.NewOrgName]) || '',
            accepted: legalAccepted,
            onAccept: onSetLegalAccepted,
            onSubmit: onAcceptLegalAgreements,
            onBack: () => gotoStep(_types.SetupSteps.PRODUCT_INTEREST),
            error: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 259}}
          )
        )
      case _types.SetupSteps.FINISH: {
        // Invited / join-request: the legacy download screen. Its skip is
        // login-only now — `SIGN_UP_COMPLETE` already fired at submission.
        return _react2.default.createElement(_Sections.FinishSection, { onFinish: onDownloadFinish, error: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 271}} )
      }
    }
  }

  // Invited / join-request signups (any existing-org relationship) skip the
  // survey and plan steps entirely — the step nav shows only the steps this
  // cohort will actually walk. Cold signups keep the full ladder until they
  // explicitly pick an existing org to join.
  // An invitation found at the Organization step puts the signup in the
  // invited cohort from that step on.
  const hasMatchedInvites = orgMatchState.status === 'ready' && orgMatchState.matches.Invites.length > 0
  const showSurveySteps = !hasMatchedInvites && (
    requestedOrgRels.length === 0 || requestedOrgRels.every(r => !_utils.isExistingOrgRel.call(void 0, r))
  )

  return (
    _react2.default.createElement(_components.SignupStepWrapper, {
      // Completed steps stay clickable through the pre-auth trial offer.
      // Invited/join-request signups submitted before FINISH, so their nav
      // locks there — revisiting would only replay an already-used token.
      gotoStep: currentStep < _types.SetupSteps.FINISH || isBridge ? gotoStep : null,
      currentStep: currentStep,
      maxStep: maxStep,
      // Org SMS verification takes the narrow card wherever it appears.
      size: pendingMFA ? 'sm' : sizes[currentStep],
      showSurveySteps: showSurveySteps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 288}}

      ,  renderContent() 
    )
  )
}

exports. default = SetupFlow
